import React, { useEffect, useRef } from "react";
import { Sheet as UISheet, SheetProps as UISheetProps } from "@bared/ui";

import { useLiveChat } from "~/hooks/useLiveChat";
import { useGoogleTagManager } from "~/hooks/useGoogleTagManager";

export interface SheetProps extends UISheetProps {
  eventTitle?: string;
}

export function Sheet({ isOpen, eventTitle, ...props }: SheetProps) {
  const liveChat = useLiveChat();
  const googleTagManager = useGoogleTagManager();
  const wasOpen = useRef(false);

  useEffect(() => {
    // Hide or show live chat.
    if (isOpen) liveChat.hide();
    else liveChat.show();

    // Only trigger analytics when sheet is opened (not when it's closed)
    if (isOpen && !wasOpen.current) {
      googleTagManager.push({
        event: "Sheet Opened",
        properties: {
          title: eventTitle ?? "Untitled sheet",
        },
      });
    }

    // Update the refs to track previous state
    wasOpen.current = isOpen;
  }, [isOpen, eventTitle, liveChat, googleTagManager]);

  return <UISheet {...props} isOpen={isOpen} />;
}
